import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { kitControllerGetAll } from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

export const useKitCollectionsData = (
  groupUuid: string | null,
  kitUuid: string | null,
) => {
  const { data: collections, isLoading } = useQuery({
    enabled: useIsApiReady() && !!groupUuid && !!kitUuid,
    initialData: [],
    queryKey: queryKeys.kitCollections(groupUuid!, kitUuid!),
    queryFn: () =>
      kitControllerGetAll({
        query: {
          filter: { type: "collection", linkedToKitUuid: kitUuid! },
        },
      }).then((res) => res.data?.data ?? []),
  });

  return { collections, isLoading };
};

// Published-only, so this key stays separate from admin collection lists.
// Prefix invalidation of `queryKeys.kits(groupUuid)` still refreshes it.
export const useGroupCollectionsData = (groupUuid: string | null) => {
  const { data: collections, isLoading } = useQuery({
    enabled: useIsApiReady() && !!groupUuid,
    initialData: [],
    queryKey: queryKeys.kits(groupUuid!, {
      type: "collection",
      isPublished: true,
    }),
    queryFn: () =>
      kitControllerGetAll({
        query: {
          filter: {
            type: "collection",
            groupUuid: groupUuid!,
            isPublished: true,
          },
        },
      }).then((res) => res.data?.data ?? []),
  });

  return { collections, isLoading };
};
